import styled from 'styled-components'

export const QrCodeWrapper = styled.div`
  background: #ffffff;

  width: 100%;
  margin: 0 1rem;
  max-width: 52rem;
  padding: 2.5rem 3.5rem;

  color: #000000;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: normal;
  line-height: 2rem;

  .code {
    margin: 5rem 0;
  }
`
